(function($, undefined) {
	'use strict';
	
	var tooltip;
	var main;
	var max = {};
	// var max;
	var selectedList;
	var notSelectedList;
	var delBtn;
	var moveUpBtn;
	var moveDownBtn;
	var featuredBtn;
	var changeDemoColumnBtn;
	
	var processItem = function (t, tag) {
		var ctn = t.closest('.tab-ctn');
		var personId = t.attr("data-personId");
		var data;
		
		console.log('before: ' + t.attr('data-position'));

		$('.demo-selection-item', selectedList).each(function (i) {
			var t = $(this);
			t.attr('data-position', i);
		});
		handleDemoTooltips();

		console.log('after: ' + t.attr('data-position'));

		if(tag === 'selected') {
			data = {
				id: t.attr('data-id'),
				field10: tag,
				targetField1: "demo",
				field: "field9",
				value: personId,
				targetPosition: t.attr('data-position'),
				targetPositionField: "field11",
				ajax: true
			};
		} else {
			data = {
				id: t.attr('data-id'),
				field10: tag,
				ajax: true
			};			
		}
		
		if ($('.demo-selection-item-date', t).html() !== undefined) {
			if ($('.demo-selection-item-date', t).html().length === 0) {
				data.dateField1Year = new Date().getFullYear();
				data.dateField1Month = new Date().getMonth();
				data.dateField1Day = new Date().getDate();
				data.dateField1Hour = new Date().getHours();
				data.dateField1Minute = new Date().getMinutes();
				data.dateField1Second = new Date().getSeconds();
			}
		}

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: data,
			success: function (response) {
				console.log(response);
			}
		});
	};
	
	var delItem = function () {
		var t = $(this);
		t.closest('.popup').addClass('is-processing');
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: {
				id: t.attr('data-item-id'),
				delete: true,
				ajax: true
			},
			success: function (response) {
				window.location.reload();
			}
		});
	};

	var moveDemoUp = function() {
		var	id = $(this).closest('.tooltip-big-ctn').attr('data-id');
		var demo = $('.demo-selection-item[data-id=' + id + ']');
		var parentCtn = demo.closest(selectedList);
		var prevSibling = demo.prev('.demo-selection-item');

		if (prevSibling.length) {
			demo.remove();
			parentCtn.find(prevSibling).before(demo);
			processItem(demo, 'selected');
			tooltip.outsideTooltipClose();
			tooltip.resetTooltips();
		}
	};

	var moveDemoDown = function() {
		var	id = $(this).closest('.tooltip-big-ctn').attr('data-id');
		var demo = $('.demo-selection-item[data-id=' + id + ']');
		var parentCtn = demo.closest(selectedList);
		var nextSibling = demo.next('.demo-selection-item');

		if (nextSibling.length) {
			demo.remove();
			parentCtn.find(nextSibling).after(demo);
			processItem(demo, 'selected');
			tooltip.outsideTooltipClose();
			tooltip.resetTooltips();
		}
	};

	var featureDemo = function() {
		var t = $(this);
		var maxAllowed = max[t.closest('.tab-ctn').index()];
		var	id = t.closest('.tooltip-big-ctn').attr('data-id');
		var demo = $('.demo-selection-item[data-id=' + id + ']');
		var ctn = demo.closest(main).find(selectedList);

		if (maxAllowed === 'infinite' || (maxAllowed !== 'infinite' && (ctn.length || (demo.closest('.demo-selection-list').length && ctn.find('.demo-selection-item').length < maxAllowed)))) {
			demo.remove();
			ctn.prepend(demo);
			processItem(demo, 'selected');
			tooltip.outsideTooltipClose();
			tooltip.resetTooltips();
		}
	};

	var changeDemoColumn = function() {
		var t = $(this);
		var	id = t.closest('.tooltip-big-ctn').attr('data-id');
		var demo = $('.demo-selection-item[data-id=' + id + ']');
		var maxAllowed = max[demo.closest('.tab-ctn').index()];
		var selectedCtn = demo.closest(main).find(selectedList);
		var isSelected = demo.closest(selectedList).length;
		var unselectedCtn = demo.closest(main).find(notSelectedList);
		var isUnselected = demo.closest(notSelectedList).length;

		console.log(maxAllowed)
		console.log(demo.closest('.demo-selection-list').length)
		console.log(selectedCtn.find('.demo-selection-item').length)

		if (isSelected) {
			demo.remove();
			unselectedCtn.append(demo);
			processItem(demo, 'unselected');
			tooltip.outsideTooltipClose();
			tooltip.resetTooltips();
		} else {
			if (maxAllowed === 'infinite' || (maxAllowed !== 'infinite' && (demo.closest('.demo-selection-list').length && selectedCtn.find('.demo-selection-item').length < maxAllowed))) {
				demo.remove();
				selectedCtn.append(demo);
				processItem(demo, 'selected');
				tooltip.outsideTooltipClose();
				tooltip.resetTooltips();
			}
		}
	};

	var handleDemoTooltips = function() {
		$('.demo-selection-item').each(function() {
			var demo = $(this);
			var maxAllowed = max[demo.closest('.tab-ctn').index()];
			var id = demo.attr('data-id');
			var tooltip = $('.demo-selection-item-tooltip[data-id=' + id + ']');
			var selectedCtn = demo.closest(main).find(selectedList);
			var isSelected = demo.closest(selectedList).length;
			var isUnselected = demo.closest(notSelectedList).length;

			if (!isSelected) {
				tooltip.find(moveUpBtn).addClass('hide');
				tooltip.find(moveDownBtn).addClass('hide');
			} else {
				tooltip.find(moveUpBtn).removeClass('hide');
				tooltip.find(moveDownBtn).removeClass('hide');
			}

			if (maxAllowed === 'infinite' || (maxAllowed !== 'infinite' && (demo.closest('.demo-selection-list').length && selectedCtn.find('.demo-selection-item').length < maxAllowed))) {
				tooltip.find(featuredBtn).removeClass('disabled');
				tooltip.find(changeDemoColumnBtn).removeClass('disabled');
			} else {
				if (!isSelected) {
					tooltip.find(featuredBtn).addClass('disabled');
					tooltip.find(changeDemoColumnBtn).addClass('disabled');
				}
			}

			if (demo.index() === 0) {
				tooltip.find(moveUpBtn).addClass('disabled');
				if (isSelected) {
					tooltip.find(featuredBtn).addClass('disabled');
				}
			} else {
				tooltip.find(moveUpBtn).removeClass('disabled');
				tooltip.find(featuredBtn).removeClass('disabled');
			}

			if (demo.index() === selectedCtn.find('.demo-selection-item').length - 1) {
				tooltip.find(moveDownBtn).addClass('disabled');
			} else {
				tooltip.find(moveDownBtn).removeClass('disabled');
			}
		});
	};

	var manageHandles = function(t) {
		var i = t.closest('.tab-ctn').index();
		var count = parseInt(t.attr('data-count'));
		var obj;

		max[i] = t.attr('data-max') !== 'infinite' ? parseInt(t.attr('data-max')) : 'infinite';

		var settings = {
			handle: '.demo-selection-item-handle',
			items: '.demo-selection-item',
			scrollSensitivity: 40,
			helper: fixHelper,
			start: function(event, ui) {
				t.addClass('from-unselected');
				obj = ui.item;
			},
			receive: function(event, ui) {
				var newCount = $('.demo-selection-selected-body .demo-selection-item', t).length;
				if ($('.demo-selection').attr('data-max') !== undefined && max[i] !== 'infinite') {
					if (newCount > max[i]) {
						$(ui.sender).sortable('cancel');
						
						if ($('.change-plan-popup-btn', t).length > 0) {
							$('.change-plan-popup-btn', t).trigger('click');
						}
					}
				}
			},
			stop: function(event, ui) {
				var newCount = $('.demo-selection-selected-body .demo-selection-item', t).length;
				var $targ = obj.prev(".demo-selection-item");
				var index = parseInt($targ.attr("data-position")) + 1;

				if ($targ.length === 0) {
					index = 0;
				}
				t.attr('data-count', newCount);
				$('.demo-selection-selected-title-count', t).html(newCount);
				
				t.removeClass('from-unselected');
				
				if(max[i] === index) {
					t.addClass('max-reached');
				} else {
					t.removeClass('max-reached');
				}
				
				var status = "selected";
				var dropList = ui.item.parent();
				if(!dropList.hasClass("demo-selection-selected-body")){
					status = "unselected";
				} 
				processItem(obj, status);
				tooltip.resetTooltips();
			}
		};
		
		$('.demo-selection-selected-body', t).sortable($.extend({}, settings, {
			connectWith: '.demo-selection-list-body',
		}));
		$('.demo-selection-list-body', t).sortable($.extend({}, settings, {
			connectWith: '.demo-selection-selected-body'
		}));
	};

	var init = function() {
		tooltip = Fw.component.models().tooltip;
		main = $('.demo-selection');
		selectedList = $('.demo-selection-selected-body');
		notSelectedList = $('.demo-selection-list-body');
		delBtn = $('.demo-del-form-confirm');

		moveUpBtn = $('.move-demo-up-btn');
		moveDownBtn = $('.move-demo-down-btn');
		featuredBtn = $('.move-demo-to-featured-btn');
		changeDemoColumnBtn = $('.change-demo-column-btn');

		moveUpBtn.click(moveDemoUp);
		moveDownBtn.click(moveDemoDown);
		featuredBtn.click(featureDemo);
		changeDemoColumnBtn.click(changeDemoColumn);

		main.each(function() {
			manageHandles($(this));
		});

		handleDemoTooltips();

		$('.demo-selection-list-body, .demo-selection-selected-body', main).scroll(function () {
			$('.tooltip-big-ctn').removeClass('show');
			tooltip.resetTooltips();
			tooltip.outsideTooltipClose();
		});

		$('.demos-selection-tab').click(function() {
			setTimeout(function() {
				tooltip.resetTooltips();
			}, 500);
		});
		
		delBtn.click(delItem);
	};
	
	var fixHelper = function (e, ui) {	  
		ui.children().each(function () {
			$(this).width($(this).width());
		});
		return ui;
	};
	
	$(init);

})(jQuery);
